module.exports = __webpack_public_path__ + "img/@logo_hanabank.7fd6f2d5.png";